import { combineReducers } from "redux";
import {
  SELECTING_FEATURE,
  FETCH_SCHEDULE_DATE,
  UPDATE_SCHEDULE_DATE,
  UPDATE_DATE_PROPS,
  TOTAL_APP_MODULES,
  ACTION_APP_MODULES,
  CONTENT_DASHBOARD_STATUS,
  EDIT_SEO_CODE,
  CONTENT_DISPLAY_ITEMS,
  APP_MENU,
  APP_BTM_MENU_FIXED,
  FIXED_FEATURES,
} from "GeneralTabAction";

export function selectedFeaturesReducer(state = [], action) {
  switch (action.type) {
    case SELECTING_FEATURE:
      return action.payload;
    default:
      return state;
  }
}

export function fetchScheduleDates(state = [], action) {
  switch (action.type) {
    case FETCH_SCHEDULE_DATE:
      return action.payload;
    default:
      return state;
  }
}

export function updateScheduleDates(state = [], action) {
  switch (action.type) {
    case UPDATE_SCHEDULE_DATE:
      return action.payload;
    default:
      return state;
  }
}

export function DatePropsReducer(
  state = { from: null, to: null, enteredTo: null },
  action
) {
  switch (action.type) {
    case UPDATE_DATE_PROPS:
      return action.payload;
    default:
      return state;
  }
}

export function totalAppModules(state = [], action) {
  switch (action.type) {
    case TOTAL_APP_MODULES:
      return action.payload;
    default:
      return state;
  }
}

export function actionAppModules(state = [], action) {
  switch (action.type) {
    case ACTION_APP_MODULES:
      return action.payload;
    default:
      return state;
  }
}

export function contentDashboard(state = [], action) {
  switch (action.type) {
    case CONTENT_DASHBOARD_STATUS:
      return action.payload;
    default:
      return state;
  }
}

export function contentDisplayItems(state = [], action) {
  switch (action.type) {
    case CONTENT_DISPLAY_ITEMS:
      return action.payload;
    default:
      return state;
  }
}

export function editSeoCode(state = false, action) {
  switch (action.type) {
    case EDIT_SEO_CODE:
      return action.payload;
    default:
      return state;
  }
}

export function appMenuReducer(state = [], action) {
  switch (action.type) {
    case APP_MENU:
      return action.payload;
    default:
      return state;
  }
}

export function appBtmMenuFixed(state = [], action) {
  switch (action.type) {
    case APP_BTM_MENU_FIXED:
      return action.payload;
    default:
      return state;
  }
}

export function fixedFeatures(state = [], action) {
  switch (action.type) {
    case FIXED_FEATURES:
      return action.payload;
    default:
      return state;
  }
}
